
<div>
	<v-container align="center" justify="center" class="pa-5 pb-0">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap"
					><h1>{{ getLabel('companyAddress', 'Practice Address') }}</h1></v-list-item-title
				>
				<v-list-item-subtitle class="text-center text-wrap">{{
					getLabel('companyAddressSectionDescription', 'Make it easy for a locum to find you, where are you located?')
				}}</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-container>
		<v-form ref="practiceAddressForm" v-model="valid" class="pa-4 pt-0">
			<v-card-text align="center" justify="center" class="justify-center text-center">
				<v-row
					><v-col> <v-text-field v-model="streetAddress" label="Street address" outlined :rules="streetAddressRules"></v-text-field> </v-col
				></v-row>

				<v-row
					><v-col>
						<v-text-field
							v-model="building"
							:label="getLabel('buildingLabel', 'Building')"
							:hint="getLabel('buildingHint', 'Office park, Building, Suite, etc…')"
							persistent-hint
							outlined
						></v-text-field> </v-col
				></v-row>

				<v-row>
					<v-col><v-select v-model="provinceSelected" :rules="provinceRules" outlined :items="province_computed" persistent-hint label="Province"></v-select></v-col>
				</v-row>
				<v-row>
					<v-col
						><v-select
							v-model="provinceRegion"
							:rules="regionRules"
							outlined
							:items="region_computed"
							:disabled="provinceSelected ? false : true"
							persistent-hint
							:label="region"
							:hint="provinceSelected ? 'City/District/Region' : 'Please select a province.'"
						></v-select
					></v-col>
				</v-row>

				<v-row
					><v-col> <v-text-field v-model="postalCode" label="Postal code" :rules="postalCodeRules" outlined></v-text-field> </v-col
				></v-row>
			</v-card-text>
		</v-form>
	</v-container>
</div>
